/** Clavier tactile intégré à la borne (mode lettres ou pavé numérique). */
const ROWS_TEXT = [
  ['A', 'Z', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
  ['Q', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M'],
  ['W', 'X', 'C', 'V', 'B', 'N', '-', "'"],
];

export function Keyboard({
  mode,
  value,
  label,
  placeholder,
  onKey,
  onBackspace,
  onClose,
}: {
  mode: 'text' | 'tel';
  value: string;
  label: string;
  placeholder?: string;
  onKey: (k: string) => void;
  onBackspace: () => void;
  onClose: () => void;
}) {
  const preview = (
    <div className="kb-preview">
      <span className="lb">{label}</span>
      <span className="val">
        {value ? value : <span className="ph">{placeholder}</span>}
        <span className="kb-cursor">▏</span>
      </span>
    </div>
  );

  if (mode === 'tel') {
    return (
      <div className="kb kb-tel" onMouseDown={(e) => e.preventDefault()}>
        {preview}
        {[['1', '2', '3'], ['4', '5', '6'], ['7', '8', '9'], ['+', '0', '⌫']].map((row, i) => (
          <div className="kb-row" key={i}>
            {row.map((k) => (
              <button
                key={k}
                className={`kb-key${k === '⌫' ? ' del' : ''}`}
                onClick={() => (k === '⌫' ? onBackspace() : onKey(k))}
              >
                {k}
              </button>
            ))}
          </div>
        ))}
        <div className="kb-row">
          <button className="kb-key wide go" onClick={onClose}>OK ✓</button>
        </div>
      </div>
    );
  }

  return (
    <div className="kb" onMouseDown={(e) => e.preventDefault()}>
      {preview}
      {ROWS_TEXT.map((row, i) => (
        <div className="kb-row" key={i}>
          {row.map((k) => (
            <button key={k} className="kb-key" onClick={() => onKey(k)}>{k}</button>
          ))}
          {i === ROWS_TEXT.length - 1 && (
            <button className="kb-key del" onClick={onBackspace}>⌫</button>
          )}
        </div>
      ))}
      <div className="kb-row">
        <button className="kb-key wide" onClick={() => onKey(' ')}>espace</button>
        <button className="kb-key wide go" onClick={onClose}>OK ✓</button>
      </div>
    </div>
  );
}
